import axios from '@/libs/http'

export const getRandomList = (pageNo, pageSize) => {
    return axios.request({
        url: '/s/c/order/randomList',
        params: {
            pageNo,
            pageSize
        },
        method: 'get'
    })
}